import { useEffect, useState } from 'react';

export function isAgentWorkspace(path: string) {
  return path === '/' || /^\/(studio|slides|chat|agent-workspace)(\/|$)/.test(path)
    || /^\/campaign-workspaces\/[^/]+/.test(path)
    || /^\/forms\/[^/]+\/edit\/?$/.test(path);
}

export function useWorkspaceNavigation(path: string) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => window.innerWidth < 768 || isAgentWorkspace(path));
  useEffect(() => {
    if (isAgentWorkspace(path)) setIsSidebarCollapsed(true);
  }, [path]);
  useEffect(() => {
    const resize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(previous => {
        if (mobile !== previous) setIsSidebarCollapsed(true);
        return mobile;
      });
    };
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  return { isMobile, isSidebarCollapsed, toggleSidebar: () => setIsSidebarCollapsed(value => !value) };
}
